import * as Yup from "yup";

let LoginFormValidation = Yup.object().shape({
  userName: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});

const productFormValidation = Yup.object().shape({
  name: Yup.string().required("Title is required"),
  category: Yup.string().required("Category is required"),
  code: Yup.string().required("Code is required"),
  weight: Yup.string().required("Weight is required"),
  selling_price: Yup.string().required("Selling Price is required"),
});
const customerFormValidation = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  email: Yup.string()
    .required("Email is required")
    .matches(
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      "Email is not valid"
    ),
  address: Yup.string().required("Address is required"),
  phoneNumber: Yup.string().required("Phone is required"),
});
const categoryFormValidation = Yup.object().shape({
  name: Yup.string().required("Title is required"),
  code: Yup.string().required("Code is required"),
});
const reconcileStockFormValidation = Yup.object().shape({
  product: Yup.string().required("Product is required"),
  quantity: Yup.string().required("Quantity is required"),
  description: Yup.string().required("Description is required"),
});

const purchaseStockFormValidation = Yup.object().shape({
  orderNumber: Yup.string().required("Purchase order number is required"),
  quantity: Yup.string().required("Quantity is required"),
  weight: Yup.string().required("Description is required"),
  costPrice: Yup.string().required("Cost Price is required"),
});
const cutPieceFormValidation = Yup.object().shape({
  piece: Yup.string().required("Product is required"),
});
const cashOutFormValidation = Yup.object().shape({
  debit: Yup.string().required("Amount is required").min(1),
  note: Yup.string().required("Note is required"),
});

export {
  LoginFormValidation,
  productFormValidation,
  categoryFormValidation,
  customerFormValidation,
  reconcileStockFormValidation,
  cutPieceFormValidation,
  cashOutFormValidation,
  purchaseStockFormValidation,
};
